import createEvent from "@/hooks/event";
import { cn } from "@/lib/utils";
import logo from "@root/public/images/logo.png";

let src = logo;

const [useListener, dispatch] = createEvent(() => src);

export const setSrcLogo = (value: string) => {
  src = value;
  dispatch();
};

export default function Logo({ className }: { className?: string }) {
  useListener();

  return (
    <div className={cn("w-full h-fit", className)}>
      <img src={logo} className="object-contain rounded aspect-video h-32" />
    </div>
  );
}
